// Retrieve focusable elements from a container
function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

// Check if mobile
if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
  window.isMobile = true;
} else {
  window.isMobile = false;
}

// Detail/summary elements a11y
document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute('role', 'button');
  summary.setAttribute('aria-expanded', summary.parentNode.hasAttribute('open'));

  if (summary.nextElementSibling.getAttribute('id')) {
    summary.setAttribute('aria-controls', summary.nextElementSibling.id);
  }

  summary.addEventListener('click', (event) => {
    event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
  });

  if (summary.closest('header-drawer')) return;
  summary.parentElement.addEventListener('keyup', onKeyUpEscape);
});

// Trap focus helper
const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (event.target !== container && event.target !== last && event.target !== first) return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    // On the first focusable element and tab backward, focus the last element.
    if ((event.target === container || event.target === first) && event.shiftKey) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  elementToFocus.focus();

  if (
    elementToFocus.tagName === 'INPUT' &&
    ['search', 'text', 'email', 'url'].includes(elementToFocus.type) &&
    elementToFocus.value
  ) {
    elementToFocus.setSelectionRange(0, elementToFocus.value.length);
  }
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(':focus-visible');
} catch (e) {
  focusVisiblePolyfill();
}

// Focus visible polyfill
function focusVisiblePolyfill() {
  const navKeys = [
    'ARROWUP',
    'ARROWDOWN',
    'ARROWLEFT',
    'ARROWRIGHT',
    'TAB',
    'ENTER',
    'SPACE',
    'ESCAPE',
    'HOME',
    'END',
    'PAGEUP',
    'PAGEDOWN',
  ];
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener('keydown', (event) => {
    if (navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener('mousedown', (event) => {
    mouseClick = true;
  });

  window.addEventListener(
    'focus',
    () => {
      if (currentFocusedElement) currentFocusedElement.classList.remove('focused');

      if (mouseClick) return;

      currentFocusedElement = document.activeElement;
      currentFocusedElement.classList.add('focused');
    },
    true
  );
}

// Pause all playing media helper
function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
  });
  document.querySelectorAll('.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('video').forEach((video) => video.pause());
  document.querySelectorAll('product-model').forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

// Escape key helper
function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;

  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.setAttribute('aria-expanded', false);
  summaryElement.focus();
}

// Scroll bar width helpers
function getScrollBarWidth(initial = false) {
  if (document.documentElement.scrollHeight <= window.innerHeight) {
    return 0;
  }

  const scrollDiv = document.createElement('div');
  scrollDiv.className = 'scrollbar-measure';
  document.body.appendChild(scrollDiv);

  const scrollbarWidth = scrollDiv.offsetWidth - scrollDiv.clientWidth;

  document.body.removeChild(scrollDiv);
  if (initial) {
    document.documentElement.style.setProperty(
      '--scrollbar-gutter',
      `${document.documentElement.scrollHeight <= window.innerHeight ? 0 : scrollbarWidth}px`
    );
    return;
  }
  return scrollbarWidth;
}

getScrollBarWidth(true);

function addScrollbarPadding() {
  if (window.isMobile) return;
  document.body.style.paddingRight = `${getScrollBarWidth()}px`;
  document.body.classList.add('scrollbar-adjust');
}

function removeScrollbarPadding() {
  if (window.isMobile) return;
  document.body.style.paddingRight = '0px';
  document.body.classList.remove('scrollbar-adjust');
}

// Show overlay
function showFullOverlay(topElement) {
  const fullOverlay = document.querySelector('#OverlayFull');
  if (topElement) topElement.style.zIndex = 11;
  fullOverlay.classList.add('is-visible');
}

// Hide overlay
function hideFullOverlay(topElement) {
  const fullOverlay = document.querySelector('#OverlayFull');
  fullOverlay.classList.remove('is-visible');
  fullOverlay.addEventListener(
    'transitionend',
    () => {
      if (topElement) topElement.style.zIndex = null;
    },
    { once: true }
  );
}

// Debounce helper
function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

// Throttle helper
function throttle(fn, delay) {
  let lastCall = 0;
  return function (...args) {
    const now = new Date().getTime();
    if (now - lastCall < delay) {
      return;
    }
    lastCall = now;
    return fn(...args);
  };
}

// Fetch config helper
function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Accept: `application/${type}`,
    },
  };
}

// Shopify JS
if (typeof window.Shopify == 'undefined') {
  window.Shopify = {};
}

if (Shopify.designMode) {
  document.documentElement.classList.add('shopify-design-mode');
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  };
};

Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener
    ? target.addEventListener(eventName, callback, false)
    : target.attachEvent('on' + eventName, callback);
};

Shopify.postLink = function (path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};

  var form = document.createElement('form');
  form.setAttribute('method', method);
  form.setAttribute('action', path);

  for (var key in params) {
    var hiddenField = document.createElement('input');
    hiddenField.setAttribute('type', 'hidden');
    hiddenField.setAttribute('name', key);
    hiddenField.setAttribute('value', params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (country_domid, province_domid, options) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler, this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function () {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function (e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    var raw = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = '';
    }
  },

  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  },
};

Shopify.money_format = "${{amount}}";
Shopify.formatMoney = function (cents, format) {
  if (typeof cents == 'string') { cents = cents.replace('.', ''); }
  var value = '';
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  var formatString = (format || this.money_format);

  function defaultOption(opt, def) {
    return (typeof opt == 'undefined' ? def : opt);
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ',');
    decimal = defaultOption(decimal, '.');

    if (isNaN(number) || number == null) { return 0; }

    number = (number / 100.0).toFixed(precision);

    var parts = number.split('.'),
      dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
      cents = parts[1] ? (decimal + parts[1]) : '';

    return dollars + cents;
  }

  switch (formatString.match(placeholderRegex)[1]) {
    case 'amount':
      value = formatWithDelimiters(cents, 2);
      break;
    case 'amount_no_decimals':
      value = formatWithDelimiters(cents, 0);
      break;
    case 'amount_with_comma_separator':
      value = formatWithDelimiters(cents, 2, '.', ',');
      break;
    case 'amount_no_decimals_with_comma_separator':
      value = formatWithDelimiters(cents, 0, '.', ',');
      break;
  }

  return formatString.replace(placeholderRegex, value);
};

// Perform storefront request
async function storefrontRequest(queryString) {
  try {
    const queryConstructor = () => `query ${queryString}`;
    const response = await fetch(window.graphqlUrl, {
      async: true,
      crossDomain: true,
      method: 'POST',
      headers: {
        'X-Shopify-Storefront-Access-Token': window.storefrontAccessToken,
        'Content-Type': 'application/graphql',
      },
      body: queryConstructor(),
    });
    const jsonData = await response.json();
    // console.log(jsonData);
    return jsonData.data;
  } catch (error) {
    console.error('Error fetching Shopify data:', error);
    throw error;
  }
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true });

    this.input.addEventListener('change', this.onInputChange.bind(this));
    this.querySelectorAll('button').forEach((button) =>
      button.addEventListener('click', this.onButtonClick.bind(this))
    );
  }

  quantityUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.validateQtyRules();
    this.quantityUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.quantityUpdate, this.validateQtyRules.bind(this));
  }

  disconnectedCallback() {
    if (this.quantityUpdateUnsubscriber) {
      this.quantityUpdateUnsubscriber();
    }
  }

  onInputChange(event) {
    this.validateQtyRules();
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
  }

  validateQtyRules() {
    const value = parseInt(this.input.value);
    if (this.input.min) {
      const min = parseInt(this.input.min);
      const buttonMinus = this.querySelector(".quantity__button[name='minus']");
      buttonMinus.classList.toggle('disabled', value <= min);
    }
    if (this.input.max) {
      const max = parseInt(this.input.max);
      const buttonPlus = this.querySelector(".quantity__button[name='plus']");
      buttonPlus.classList.toggle('disabled', value >= max);
    }
  }
}

customElements.define('quantity-input', QuantityInput);

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector('details');

    this.addEventListener('keyup', this.onKeyUp.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll('summary').forEach((summary) =>
      summary.addEventListener('click', this.onSummaryClick.bind(this))
    );
    this.querySelectorAll('button:not(.localization-selector, .menu-drawer__submenu-button, .details__summary__button)').forEach((button) =>
      button.addEventListener('click', this.onCloseButtonClick.bind(this))
    );
  }

  onKeyUp(event) {
    if (event.code.toUpperCase() !== 'ESCAPE') return;

    const openDetailsElement = event.target.closest('details[open]');
    if (!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle
      ? this.closeMenuDrawer(event, this.mainDetailsToggle.querySelector('summary'))
      : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const parentMenuElement = detailsElement.closest('.has-submenu');
    const isOpen = detailsElement.hasAttribute('open');
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    function addTrapFocus() {
      trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('button'));
      summaryElement.nextElementSibling.removeEventListener('transitionend', addTrapFocus);
    }

    if (detailsElement === this.mainDetailsToggle) {
      if (isOpen) event.preventDefault();
      isOpen ? this.closeMenuDrawer(event, summaryElement) : this.openMenuDrawer(summaryElement);

      if (window.matchMedia('(max-width: 990px)')) {
        document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
      }
    } else {
      setTimeout(() => {
        detailsElement.classList.add('menu-opening');
        summaryElement.setAttribute('aria-expanded', true);
        parentMenuElement && parentMenuElement.classList.add('submenu-open');
        !reducedMotion || reducedMotion.matches
          ? addTrapFocus()
          : summaryElement.nextElementSibling.addEventListener('transitionend', addTrapFocus);
      });
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });
    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add('overflow-hidden');
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event === undefined) return;

    this.mainDetailsToggle.classList.remove('menu-opening');
    this.mainDetailsToggle.querySelectorAll('details').forEach((details) => {
      details.removeAttribute('open');
      details.classList.remove('menu-opening');
    });
    this.mainDetailsToggle.querySelectorAll('.submenu-open').forEach((submenu) => {
      submenu.classList.remove('submenu-open');
    });
    document.body.classList.remove('overflow-hidden');
    removeTrapFocus(elementToFocus);
    this.closeAnimation(this.mainDetailsToggle);
  }

  onFocusOut() {
    setTimeout(() => {
      if (this.mainDetailsToggle.hasAttribute('open') && !this.mainDetailsToggle.contains(document.activeElement))
        this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest('details');
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    const parentMenuElement = detailsElement.closest('.submenu-open');
    parentMenuElement && parentMenuElement.classList.remove('submenu-open');
    detailsElement.classList.remove('menu-opening');
    detailsElement.querySelector('summary').setAttribute('aria-expanded', false);
    removeTrapFocus(detailsElement.querySelector('summary'));
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute('open');
        if (detailsElement.closest('details[open]')) {
          trapFocus(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'));
        }
      }
    };

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define('menu-drawer', MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  openMenuDrawer(summaryElement) {
    this.header = this.header || document.querySelector('.header');
    document.documentElement.style.setProperty(
      '--header-bottom-position',
      `${parseInt(this.header.getBoundingClientRect().bottom)}px`
    );
    this.header.classList.add('menu-open');

    // Change header style to solid on menu open
    this.headerComponent = this.headerComponent || document.querySelector('header-component');
    this.initialHeaderStyle = this.headerComponent.dataset.style;
    if (this.initialHeaderStyle !== 'solid') {
      this.headerComponent.setAttribute('data-style', 'solid');
    }

    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });

    summaryElement.setAttribute('aria-expanded', true);
    window.addEventListener('resize', this.onResize);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add('overflow-hidden');
  }

  closeMenuDrawer(event, elementToFocus) {
    if (!elementToFocus) return;
    super.closeMenuDrawer(event, elementToFocus);
    if (this.initialHeaderStyle !== 'solid') {
      this.headerComponent.setAttribute('data-style', this.initialHeaderStyle);
    }
    this.header.classList.remove('menu-open');
    window.removeEventListener('resize', this.onResize);
  }

  onResize = () => {
    this.header &&
      document.documentElement.style.setProperty(
        '--header-bottom-position',
        `${parseInt(this.header.getBoundingClientRect().bottom)}px`
      );
    document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
  };
}

customElements.define('header-drawer', HeaderDrawer);

class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends HTMLElement {
  constructor() {
    super();
    this.header = document.querySelector("header-component");
    this.container = this.querySelector(".header-menu");
    this.submenu = this.querySelector(".header__submenu");
    this.toggle = this.querySelector("[data-toggle]");
    this.overlay = document.querySelector(".header__overlay");
    this.overlayListener = this.closeSubmenu.bind(this);
    this.onHoverTimeout = null;
  }

  connectedCallback() {
    // this.toggle.addEventListener("click", this.onClick.bind(this));
    this.container.addEventListener("mouseover", this.onMouseOver.bind(this));
    this.container.addEventListener("mouseout", this.onMouseOut.bind(this));
  }

  onClick() {
    if (this.container.dataset.submenuOpen === "true") {
      this.closeSubmenu();
    } else {
      this.openSubmenu();
    }
  }

  onMouseOver() {
    if (this.onHoverTimeout) clearTimeout(this.onHoverTimeout);
    this.openSubmenu();
  }

  onMouseOut() {
    if (this.container.matches(":hover") || this.submenu.matches(":hover")) return;
    if (Array.from(document.querySelectorAll(".header-menu")).some((el) => el.matches(":hover"))) {
      this.closeSubmenu();
      return;
    }
    this.onHoverTimeout = setTimeout(() => {
      this.closeSubmenu();
    }, 200);
  }

  closeSubmenu() {
    this.container.setAttribute("data-submenu-open", "false");
    this.header.removeAttribute("data-submenu-open");
    this.hideOverlay();
  }

  openSubmenu() {
    // this.closeOpenMenus();
    this.container.setAttribute("data-submenu-open", "true");
    this.header.setAttribute("data-submenu-open", "true");
    document.addEventListener("scroll", this.closeSubmenu.bind(this), { once: true });
    this.showOverlay();
  }

  closeOpenMenus() {
    document.querySelectorAll('.header-menu[data-submenu-open="true"]').forEach((menu) => {
      menu.setAttribute("data-submenu-open", "false");
    });
  }

  showOverlay() {
    if (this.overlay.classList.contains("is-visible")) return;
    this.overlay.classList.add("is-visible");
    this.overlay.addEventListener("click", this.overlayListener);
  }

  hideOverlay() {
    if (document.querySelectorAll('.header-menu[data-submenu-open="true"]').length > 0) return;
    this.overlay.classList.remove("is-visible");
    this.overlay.removeEventListener("click", this.overlayListener);
  }
}

customElements.define("header-menu", HeaderMenu);

/*
  Header Component
  - Changes style of header bar according to scroll positon

  To do:
  - Also change style on menu open
*/

class HeaderComponent extends HTMLElement {
  constructor() {
    super();
    this.handleScroll = this.handleScroll.bind(this);
  }

  connectedCallback() {
    document.documentElement.style.setProperty(
      "--header-height",
      `${this.offsetHeight}px`
    );

    this.logo = this.querySelector('[data-transparent-logo]');

    // Get the bottom position of the logo
    this.scrollThreshold = this.logo ? this.logo.getBoundingClientRect().height : 64;

    window.addEventListener('scroll', this.handleScroll, { passive: true });
    this.handleScroll();

    if (Shopify.designMode) {
      document.addEventListener("shopify:block:select", this.onBlockSelect.bind(this));
    }
  }

  disconnectedCallback() {
    window.removeEventListener('scroll', this.handleScroll);
    if (Shopify.designMode) {
      document.removeEventListener("shopify:block:select", this.onBlockSelect);
    }
  }

  onBlockSelect(e) {
    const blockId = e.detail.blockId;
    this.targetMegaMenu = document.getElementById(blockId);
    if (!this.targetMegaMenu) return;
    this.targetMegaMenu.openSubmenu();
    document.addEventListener("shopify:block:deselect", this.onBlockDeselect.bind(this), { once: true });
  }

  onBlockDeselect(e) {
    if (!this.targetMegaMenu) return;
    this.targetMegaMenu.closeSubmenu();
  }

  handleScroll() {
    const scrollY = window.scrollY || window.pageYOffset;
    if (scrollY > this.scrollThreshold) {
      this.setAttribute('data-scrolled', 'true');
      if (this.logo) {
        this.setAttribute('data-style', 'solid');
      }
    } else {
      if (this.hasAttribute('data-scrolled')) {
        this.removeAttribute('data-scrolled');
      }
      if (this.logo) {
        this.setAttribute('data-style', 'transparent');
      }
    }
  }
}

customElements.define('header-component', HeaderComponent);

/*
  Details Modal Component
*/

class DetailsModal extends HTMLElement {
  constructor() {
    super();
    this.detailsContainer = this.querySelector("details");
    this.summaryToggle = this.querySelector("summary");
    this.header = document.querySelector(".section-header");
    this.headerDrawer = document.querySelector("header-drawer");

    this.detailsContainer.addEventListener("keyup", (event) => event.code.toUpperCase() === "ESCAPE" && this.close());
    this.summaryToggle.addEventListener("click", this.onSummaryClick.bind(this));
    this.querySelector('button[type="button"]').addEventListener("click", this.close.bind(this));

    this.summaryToggle.setAttribute("role", "button");
  }

  isOpen() {
    return this.detailsContainer.hasAttribute("open");
  }

  onSummaryClick(event) {
    event.preventDefault();
    event.target.closest("details").hasAttribute("open") ? this.close() : this.open(event);
  }

  onBodyClick(event) {
    if (!this.contains(event.target) || event.target.classList.contains("modal-overlay")) this.close(false);
  }

  open(event) {
    this.onBodyClickEvent = this.onBodyClickEvent || this.onBodyClick.bind(this);

    // if the menu drawer is open when opening search, close the menu drawer
    if (this.headerDrawer.querySelector("details").hasAttribute("open")) {
      this.headerDrawer.closeMenuDrawer(event, this.detailsContainer.querySelector('input:not([type="hidden"])'));
    }

    this.detailsContainer.classList.add("modal-opening");
    // event.target.closest("details").setAttribute("open", true);
    this.querySelector('details').setAttribute("open", true);
    setTimeout(() => {
      document.body.addEventListener("click", this.onBodyClickEvent);
    });
    showFullOverlay(this.header);
    // addScrollbarPadding();
    document.body.classList.add("overflow-hidden");

    trapFocus(
      this.detailsContainer.querySelector('[tabindex="-1"]'),
      this.detailsContainer.querySelector('input:not([type="hidden"])')
    );
  }

  close(focusToggle = true) {
    removeTrapFocus(focusToggle ? this.summaryToggle : null);
    this.detailsContainer.classList.remove("modal-opening");
    setTimeout(() => {
      this.detailsContainer.removeAttribute("open");
    }, 500);

    document.body.removeEventListener("click", this.onBodyClickEvent);
    hideFullOverlay(this.header);
    // removeScrollbarPadding();
    document.body.classList.remove("overflow-hidden");
  }
}

customElements.define("details-modal", DetailsModal);

/*
  Details Component
*/

if (!customElements.get("details-component")) {
  customElements.define(
    "details-component",
    class DetailsComponent extends HTMLElement {
      static get observedAttributes() {
        return ['data-open'];
      }

      constructor() {
        super();
      }

      connectedCallback() {
        this.button = this.querySelector("button[data-control-button]");
        this.button.addEventListener("click", this.handleButtonClick.bind(this));
      }

      handleButtonClick() {
        const isOpen = this.getAttribute('data-open') === 'true';
        this.setAttribute('data-open', !isOpen);
      }
    }
  );
}

/*
  Show More Component
*/

if (!customElements.get("show-more")) {
  customElements.define(
    "show-more",
    class ShowMore extends HTMLElement {
      constructor() {
        super();
        this.control = this.querySelector('button[data-trigger]');
        this.wrapper = this.querySelector('[data-show-more-wrapper]');
        this.content = this.querySelector('[data-show-more-content]');
        this.expandText = this.control.textContent;
        this.collapseText = this.dataset.collapseText || "Show less";
        this.defaultHeight = getComputedStyle(this).getPropertyValue('--show-more-height');
      }

      connectedCallback() {
        if (this.control) {
          this.control.addEventListener("click", this.toggleState.bind(this));
        }
      }

      toggleState() {
        if (this.getAttribute("data-expanded") !== "true") {
          this.expand();
        } else {
          this.contract();
        }
      }

      expand() {
        if (!this.content || !this.wrapper) return;
        this.wrapper.addEventListener('transitionend', () => {
          this.wrapper.style.height = 'auto';
        }, { once: true })
        this.wrapper.style.height = `${this.content.offsetHeight}px`;
        this.setAttribute("data-expanded", "true");
        this.control.textContent = this.collapseText;
      }

      contract() {
        if (!this.content || !this.wrapper) return;
        this.wrapper.style.height = `${this.content.offsetHeight}px`;
        setTimeout(() => {
          this.wrapper.style.height = `${this.defaultHeight}`;
        }, 0);
        this.setAttribute("data-expanded", "false");
        this.control.textContent = this.expandText;
      }
    }
  )
}

// MicroModal

MicroModal.init({
  onShow: (modal) => {
    document.body.classList.add('overflow-hidden');
    addScrollbarPadding();
  },
  onClose: (modal) => {
    document.body.classList.remove('overflow-hidden');
    removeScrollbarPadding();
  },
  awaitOpenAnimation: true,
});


// Lenis
// if (!Shopify.designMode) {
//   window.lenis = new Lenis({
//     autoRaf: true,
//     duration: 1
//   });
// }
